import React from 'react';
import { Provider } from 'react-redux';
import LanguagePage from './features/languages/Language';
import { store } from './store/configureStore';
import AxiosInterceptor from './AxiosInterceptor';

const App = () => (
	<Provider store={store}>
		<AxiosInterceptor>
			<LanguagePage />
		</AxiosInterceptor>
	</Provider>
);

export default App;
